Auth = require 'db/auth'
View = require 'view'
log = require 'debug/log'
track = require 'debug/track'
template = require 'views/templates/footer_chrome'

module.exports = class Footer extends View

  className: 'embedded-board-footer'

  events:
    'click .js-logout': 'logout'

  render: ->
    log('render', "rendering footer")
    @$el.html template({
      url: @options.url
      shouldDisplayLogout: @options.shouldDisplayLogout
    })
    @

  logout: ->
    if Auth.canLogIn()
      Auth.logoutPost()
      track "Log Out"



// WEBPACK FOOTER //
// ./app/scripts/views/footer/index.coffee